import {CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth-service';
import {map} from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const authGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isAuthenticated()
    .pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        }
        const urlTree = router.parseUrl('/login');
        return new RedirectCommand(urlTree, {skipLocationChange: true});
      })
    )
};
